import { Component } from 'react';
import algoliasearch from 'algoliasearch';

export default class SearchIndex extends Component {
	constructor(props) {
		super(props);
		this.client = algoliasearch('X2Q0ZAVWU3', '0eac3e36e3a6a3728486a3bd10f659b6');
		this.index = this.client.initIndex('livestreams');
	}

	getIndex() {
		return this.index;
	}
}


// WEBPACK FOOTER //
// ./src/model/SearchIndex.js